import React from 'react';
import ReactHtmlParser from 'react-html-parser';

export function textField({ 
    input,
    meta,
    label,
    placeholder,
    forwardRef,
    maxLength=null,
    customDesktopTop=false,
    customMobileTop=false,
    customMobileLabelTop=false,
    customDesktopLabelTop=false,
    customInputClass = {},
    customDivClass = {marginBottom: '50px', paddingLeft: '0px'},
    labelPosition = 'bottom'
}) {
  return (
    <div className={"form-group input-effect " + ((meta.error) ? "input-error" : "")} style={customDivClass}>
        {input.name && customDesktopTop && (
          <style 
            dangerouslySetInnerHTML={{__html: `
            label[for=${input.name}] { 
              top: ${customDesktopTop}; 
            }
          `}} />
        )}
        {input.name && customDesktopLabelTop && (
          <style dangerouslySetInnerHTML={{__html: `
            .fancy-input:focus~label[for=${input.name}],
            .fancy-input.valid~label[for=${input.name}],
            .fancy-input.error~label[for=${input.name}],
          `}} />
        )}
        {input.name && customMobileTop && (
          <style 
            dangerouslySetInnerHTML={{__html: `
              @media (max-width: 575px) {
                label[for=${input.name}] { top: ${customMobileTop}; }
              }
          `}}/>
        )}
        {input.name && customMobileLabelTop && (
          <style 
            dangerouslySetInnerHTML={{__html: `
              @media (max-width: 575px) {
                .fancy-input:focus~label[for=${input.name}],
                .fancy-input.valid~label[for=${input.name}],
                .fancy-input.error~label[for=${input.name}],
                .has-content label[for=${input.name}] { 
                  top: ${customMobileLabelTop}!important;
                }
              }
          `}}/>
        )}
        {labelPosition == 'bottom' && (
          <>
            <input 
              {...input}
              className={"fancy-input form-control full-width-input " + (meta.error && meta.touched ? "error" : "") + ((meta.valid && meta.touched || input.value && meta.valid)? "valid" : "")}
              style={customInputClass}
              type="text"
              maxLength={maxLength}
              ref={forwardRef}
              placeholder={placeholder}
            />
            <label
              className={(meta.error && meta.touched ? "error" : "") + ((meta.valid && meta.touched || input.value && meta.valid)? "valid " : " ")}
              htmlFor={input.name}
            >
                {ReactHtmlParser(label)}
            </label>
            {meta.error && meta.touched && meta.error }
          </>)}
          {labelPosition == 'top' && (
          <>
            <label
              className={(meta.error && meta.touched ? "fancy-label error" : "fancy-label ") + ((meta.valid && meta.touched || input.value && meta.valid)? "valid " : " ")}
              htmlFor={input.name}
            >
                {ReactHtmlParser(label)}
            </label>

            <input 
              {...input}
              className={"fancy-input form-control full-width-input " + (meta.error && meta.touched ? "error" : "") + ((meta.valid && meta.touched || input.value && meta.valid)? "valid" : "")}
              style={customInputClass}
              type="text"
              maxLength={maxLength}
              ref={forwardRef}
              placeholder={placeholder}
            />
            {meta.error && meta.touched && meta.error }
          </>)}
    </div>
  );
}

export function textareaField({ 
  input, 
  meta, 
  label=null, 
  placeholder,
  customInputClass = {},
  customDivClass = {},
  customLabelClass = {}
}) {
  
  return (
    <div className="form-group" style={customDivClass}>
        <label className={customLabelClass + " " + (meta.error && meta.touched ? "error" : "") + (meta.valid && meta.touched ? "valid " : " ")}
          htmlFor={input.name}>
            {label}
        </label>
        <textarea 
          {...input}
          className={"form-control full-width-input " + (meta.error && meta.touched ? "error" : "") + (meta.valid && meta.touched ? "valid" : "")}
          placeholder={placeholder}
          style={customInputClass}
        />
        {meta.error && meta.touched && meta.error }          
    </div>
  );
}

// Lists of all the NY states
export let stateList = {
  "AK" : "Alaska",
  "AL" : "Alabama",
  "AR" : "Arkansas",
  "AS" : "American Samoa",
  "AZ" : "Arizona",
  "CA" : "California",
  "CO" : "Colorado",
  "CT" : "Connecticut",
  "DC" : "District of Columbia",
  "DE" : "Delaware",
  "FL" : "Florida",
  "GA" : "Georgia",
  "GU" : "Guam",
  "HI" : "Hawaii",
  "IA" : "Iowa",
  "ID" : "Idaho",
  "IL" : "Illinois",
  "IN" : "Indiana",
  "KS" : "Kansas",
  "KY" : "Kentucky",
  "LA" : "Louisiana",
  "MA" : "Massachusetts",
  "MD" : "Maryland",
  "ME" : "Maine",
  "MI" : "Michigan",
  "MN" : "Minnesota",
  "MO" : "Missouri",
  "MS" : "Mississippi",
  "MT" : "Montana",
  "NC" : "North Carolina",
  "ND" : " North Dakota",
  "NE" : "Nebraska",
  "NH" : "New Hampshire",
  "NJ" : "New Jersey",
  "NM" : "New Mexico",
  "NV" : "Nevada",
  "NY" : "New York",
  "OH" : "Ohio",
  "OK" : "Oklahoma",
  "OR" : "Oregon",
  "PA" : "Pennsylvania",
  "PR" : "Puerto Rico",
  "RI" : "Rhode Island",
  "SC" : "South Carolina",
  "SD" : "South Dakota",
  "TN" : "Tennessee",
  "TX" : "Texas",
  "UT" : "Utah",
  "VA" : "Virginia",
  "VI" : "Virgin Islands",
  "VT" : "Vermont",
  "WA" : "Washington",
  "WI" : "Wisconsin",
  "WV" : "West Virginia",
  "WY" : "Wyoming"
}